/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './assigned/index';
export * from './user-permission-list.component';
export * from './user-permission-list.module';
export * from './user-permission-list.service';
